const errorFocus = el =>
  setTimeout(() => {
    const errorElement = el.querySelector('[data-error="true"]');

    if (errorElement) {
      errorElement.scrollIntoView({behavior: 'smooth', block: 'center'});
    }
  }, 0);

export default errorFocus;
